<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-分销-分销海报
      -->
  <div class="">
    <!--基本信息-->
    <div class="common-form">分销海报设置</div>
    <div class="poster-box d-s-s" v-loading="loading">
      <div class="left-box">
        <div v-if="currentBackdrop.src" class="img">
          <img v-img-url="currentBackdrop.src" />
        </div>
        <div v-else class="no-image">请上传海报背景图</div>
        <div class="userinfo">
          <div
            class="photo pa"
            v-drag="{type:'photo',obj:curObj}"
            :class="{ radius: form.avatar.style == 'circle' }"
            :style="'width:' + form.avatar.width + 'px;height:' + form.avatar.width + 'px;top:' + form.avatar.top + 'px;left:' + form.avatar.left + 'px;'"
          >
            <Icon :iconname="'#icon-yonghu'"></Icon>
          </div>
          <div
            class="name pa"
             v-drag="{type:'name',obj:curObj}"
            :style="'font-size:' + form.nickName.fontSize + 'px;color:' + form.nickName.color + ';top:' + form.nickName.top + 'px;left:' + form.nickName.left + 'px;'"
          >
            昵称
          </div>
          <div
            class="code pa"
            v-drag="{type:'code',obj:curObj}"
            :class="{ radius: form.qrcode.style == 'circle' }"
            :style="'width:' + form.qrcode.width + 'px;height:' + form.qrcode.width + 'px;top:' + form.qrcode.top + 'px;left:' + form.qrcode.left + 'px;'"
          >
            <img src="../../../../assets/img/qrcode.png" alt="" />
          </div>
        </div>
      </div>
      <div class="right-box flex-1">
        <el-form size="small" ref="form" :model="form" label-width="200px">
          <el-form-item label="海报背景图">
            <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
            <div class="tips">尺寸：宽750像素 高大于(等于)1200像素</div>
            
            <!-- 多图预览和切换 -->
            <div class="image-list" v-if="form.backdrop.list && form.backdrop.list.length > 0">
              <div class="image-list-title">已上传的背景图：</div>
              <div class="image-items">
                <div 
                  v-for="(item, index) in form.backdrop.list" 
                  :key="index" 
                  class="image-item"
                  :class="{ active: form.backdrop.currentIndex === index }"
                  @click="selectBackdrop(index)"
                >
                  <img :src="item.src" alt="背景图" />
                  <div class="image-actions">
                    <el-button 
                      size="mini" 
                      type="danger" 
                      icon="el-icon-delete" 
                      circle 
                      @click.stop="removeBackdrop(index)"
                    ></el-button>
                  </div>
                </div>
              </div>
              <div class="image-tips" v-if="form.backdrop.list.length > 0">
                当前使用第 {{ form.backdrop.currentIndex + 1 }} 张背景图，共 {{ form.backdrop.list.length }} 张
              </div>
            </div>
          </el-form-item>
          
          <el-form-item label="头像宽度" prop="avatar.width" :rules="[{ required: true, message: ' ' }]">
            <el-input v-model="form.avatar.width" min="30" type="number" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="头像样式">
            <el-radio v-model="form.avatar.style" label="square">正方形</el-radio>
            <el-radio v-model="form.avatar.style" label="circle">圆形</el-radio>
          </el-form-item>

          <el-form-item label="头像位置">
            <el-radio v-model="form.avatar.position" :label="'definition'">自定义</el-radio>
            <el-radio v-model="form.avatar.position" :label="'center'">强制居中</el-radio>
          </el-form-item>
        

          <el-form-item label="昵称字体大小" prop="nickName.fontSize" :rules="[{ required: true, message: ' ' }]">
            <el-input v-model="form.nickName.fontSize" min="12" type="number" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="昵称字体颜色">
            <div class="d-s-c">
              <el-color-picker v-model="form.nickName.color"></el-color-picker>
              <el-button type="button" style="margin-left: 10px;" @click="resetNickNameColor">重置</el-button>
            </div>
          </el-form-item>

          <el-form-item label="昵称位置">
            <el-radio v-model="form.nickName.position" :label="'definition'">自定义</el-radio>
            <el-radio v-model="form.nickName.position" :label="'center'">强制居中</el-radio>
          </el-form-item>
        
    

          <el-form-item label="二维码宽度 " prop="qrcode.width" :rules="[{ required: true, message: ' ' }]">
            <el-input v-model="form.qrcode.width" min="50" type="number" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="二维码样式 ">
            <el-radio v-model="form.qrcode.style" label="square">正方形</el-radio>
            <el-radio v-model="form.qrcode.style" label="circle">圆形</el-radio>
          </el-form-item>

          <el-form-item label="二维码位置">
            <el-radio v-model="form.qrcode.position" :label="'definition'">自定义</el-radio>
            <el-radio v-model="form.qrcode.position" :label="'center'">强制居中</el-radio>
          </el-form-item>
        


          <el-form-item label="重置二维码位置 ">
            <el-button type="primary" @click="reast" >重置二维码位置</el-button>
          </el-form-item>
          <!--提交-->
          <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
        </el-form>
      </div>
    </div>
    <!--上传图片组件-->
    <Upload 
      v-if="isupload" 
      :isupload="isupload" 
      :type="type" 
      :multiple="true" 
      @returnImgs="returnImgsFunc"
    >上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
import PlusApi from '@/api/plus.js';
export default {
  components: {
    Upload: Upload
  },
  data() {
    return {
      form: {
        nickName: {
          fontSize: 20,
          color:'#000000',
          left:0,
          top:0,
          position:"definition",
        },
        avatar: {
          width: 30,
          style: 'square',
          left:0,
          top:0,
          position:"definition",
        },
        qrcode: {
          width: 50,
          style: 'square',
          left:0,
          top:0,
          position:"definition",
        },
        backdrop: {
          list: [], // 存储多张背景图
          currentIndex: 0, // 当前选中的背景图索引
          currentSrc: '' // 当前显示的背景图URL
        }
      },
      loading: true,
      isupload: false,
      curObj: this,
      type: 1
    };
  },
  created() {
    this.getData();
  },
  computed: {
    // 获取当前选中的背景图
    currentBackdrop() {
      if (this.form.backdrop.list && this.form.backdrop.list.length > 0 && 
          this.form.backdrop.currentIndex !== undefined) {
        const currentItem = this.form.backdrop.list[this.form.backdrop.currentIndex];
        // 确保当前显示的URL与选中项同步
        if (currentItem && currentItem.src !== this.form.backdrop.currentSrc) {
          this.form.backdrop.currentSrc = currentItem.src;
        }
        return currentItem || {};
      }
      return {};
    }
  },
  directives: {
    drag: {
      inserted: function(el, binding) {
        let self = this;
        el.onmousedown = function(event) {
          event = event || window.event;
          let diffX = event.clientX - el.offsetLeft;
          let diffY = event.clientY - el.offsetTop;

          document.onmousemove = function(event) {
            event = event || window.event;
            let moveX = event.clientX - diffX;
            let moveY = event.clientY - diffY;
            binding.value.obj.dragDiv(moveX,moveY,binding.value.type);
          };

          document.onmouseup = function(event) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    dragDiv(x, y, type) {
      if(x < 0) x = 0;
      if(y < 0) y = 0;
      
      if(type == 'photo') {
        this.form.avatar.left = x;
        this.form.avatar.top = y;
      } else if(type == 'code') {
        this.form.qrcode.left = x;
        this.form.qrcode.top = y;
      } else if(type == 'name') {
        this.form.nickName.left = x;
        this.form.nickName.top = y;
      }
    },

    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    returnImgsFunc(e) {
      if (e && e.length > 0) {
        // 确保backdrop.list存在
        if (!this.form.backdrop.list) {
          this.form.backdrop.list = [];
        }
        
        // 将新上传的图片添加到背景图列表
        e.forEach(item => {
          this.form.backdrop.list.push({
            src: item.file_path
          });
        });
        
        // 如果当前没有选中背景图，则默认选中第一个
        if (this.form.backdrop.list.length > 0 && 
            (this.form.backdrop.currentIndex === undefined || this.form.backdrop.currentIndex === null)) {
          this.form.backdrop.currentIndex = 0;
          this.form.backdrop.currentSrc = this.form.backdrop.list[0].src;
        }
        
        this.$message({
          message: `成功上传 ${e.length} 张背景图`,
          type: 'success'
        });
      }
      this.isupload = false;
    },
    
    selectBackdrop(index) {
      this.form.backdrop.currentIndex = index;
      this.form.backdrop.currentSrc = this.form.backdrop.list[index].src;
      this.$message({
        message: `已切换到第 ${index + 1} 张背景图`,
        type: 'success'
      });
    },
    
    removeBackdrop(index) {
      if (this.form.backdrop.list.length <= 1) {
        this.$message({
          message: '至少需要保留一张背景图',
          type: 'warning'
        });
        return;
      }
      
      this.$confirm('确定要删除这张背景图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 如果要删除的是当前选中的背景图
        if (this.form.backdrop.currentIndex === index) {
          if (this.form.backdrop.list.length > 1) {
            if (index > 0) {
              this.form.backdrop.currentIndex = index - 1;
            } else {
              this.form.backdrop.currentIndex = 0;
            }
            this.form.backdrop.currentSrc = this.form.backdrop.list[this.form.backdrop.currentIndex].src;
          }
        } else if (this.form.backdrop.currentIndex > index) {
          this.form.backdrop.currentIndex--;
        }
        
        this.form.backdrop.list.splice(index, 1);
        
        this.$message({
          message: '背景图删除成功',
          type: 'success'
        });
      }).catch(() => {});
    },

    getData() {
      let self = this;
      PlusApi.GetBackground({}, true)
        .then(data => {
          let responseData = data.data.data;
          
          // 兼容旧数据格式
          if (responseData.backdrop) {
            if (responseData.backdrop.src && !responseData.backdrop.list) {
              // 旧格式：只有单个src，转换为新格式
              responseData.backdrop = {
                list: [{ src: responseData.backdrop.src }],
                currentIndex: 0,
                currentSrc: responseData.backdrop.src
              };
            } else if (responseData.backdrop.list && responseData.backdrop.list.length > 0) {
              // 新格式：确保currentSrc与当前选中项同步
              if (responseData.backdrop.currentIndex === undefined) {
                responseData.backdrop.currentIndex = 0;
              }
              responseData.backdrop.currentSrc = 
                responseData.backdrop.list[responseData.backdrop.currentIndex].src;
            }
          } else {
            // 如果没有backdrop数据，初始化
            responseData.backdrop = {
              list: [],
              currentIndex: 0,
              currentSrc: ''
            };
          }
          
          self.form = responseData;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
          self.$message({
            message: '获取数据失败',
            type: 'error'
          });
        });
    },
    
    resetNickNameColor() {
      this.form.nickName.color = '#000000';
      this.$message({
        message: '昵称颜色已重置',
        type: 'success'
      });
    },
    
    reast() {
      this.form.qrcode.top = 0;
      this.form.qrcode.left = 0;
      this.$message({
        message: '二维码位置已重置',
        type: 'success'
      });
    },
    
    onSubmit() {
      let self = this;
      
      // 验证是否有背景图
      if (!this.form.backdrop.list || this.form.backdrop.list.length === 0) {
        this.$message({
          message: '请至少上传一张背景图',
          type: 'warning'
        });
        return;
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          
          // 准备提交的数据 - 包含多张背景图
          let submitData = {
            nickName: this.form.nickName,
            avatar: this.form.avatar,
            qrcode: this.form.qrcode,
            backdrop: this.form.backdrop // 现在包含list数组
          };
          
          PlusApi.SaveBackground(
            {
              form: submitData
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {
              self.loading = false;
              self.$message({
                message: '保存失败: ' + (error.message || '请检查后端接口是否支持多图存储'),
                type: 'error'
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
/* 样式保持不变 */
.poster-box .left-box {
  position: relative;
  width: 375px;
  min-height: 640px;
  overflow: hidden;
  margin: 0 30px;
  border: 1px solid #cccccc;
  border-radius: 18px;
}
.poster-box .left-box .userinfo {
  position: absolute;
  top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.poster-box .left-box .userinfo .photo {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #ffffff;
  cursor: pointer;
}
.poster-box .left-box .userinfo .photo .svg-icon {
  width: 80%;
  height: 80%;
  font-size: 60px;
  color: #3a8ee6;
}
.poster-box .left-box .userinfo .photo img {
  width: 80%;
  height: 80%;
}
.poster-box .left-box img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.poster-box .left-box .userinfo .name {
  min-height: 30px;
  line-height: 100%;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.poster-box .left-box .userinfo .code {
  cursor: pointer;
  overflow: hidden;
}
.poster-box .left-box .userinfo .code .img {
  width: 100%;
  height: 100%;
}

.no-image {
  width: 100%;
  height: 640px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  font-size: 16px;
  background: #f5f5f5;
}

.image-list {
  margin-top: 15px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.image-list-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  font-weight: bold;
}

.image-items {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 5px;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 2px solid transparent;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  background: #fff;
}

.image-item.active {
  border-color: #409EFF;
  box-shadow: 0 0 12px rgba(64, 158, 255, 0.4);
}

.image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 2px;
  right: 2px;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-actions {
  opacity: 1;
}

.image-tips {
  margin-top: 10px;
  font-size: 12px;
  color: #409EFF;
  text-align: center;
  padding: 5px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 4px;
}

.image-items::-webkit-scrollbar {
  width: 6px;
}

.image-items::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.image-items::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.image-items::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.pa {
  position: absolute;
}

.radius {
  border-radius: 50%;
}

.d-s-s {
  display: flex;
  align-items: flex-start;
}

.d-s-c {
  display: flex;
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.max-w460 {
  max-width: 460px;
}

.common-button-wrapper {
  margin-top: 20px;
  padding-left: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/agent/poster/Poster.vue